import { Component, Input } from '@angular/core';
import { ErrorConverter, IErrorNormalized } from 'ecma-error-normalizer';
import { ErrorService } from './error.service';

@Component({
  selector: 'crtz-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

  @Input()
  set error(error: IErrorNormalized | null) {
    this.interceptedError = this.errorConverter.create(error);
  }

  get error(): IErrorNormalized | null {
    return this.interceptedError;
  }

  private interceptedError: IErrorNormalized | null = null;

  constructor(
    private service: ErrorService,
    private errorConverter: ErrorConverter
  ) { }

  isWarning(error: IErrorNormalized): boolean {
    return this.service.isWarning(error);
  }

  isError(error: IErrorNormalized): boolean {
    return this.service.isError(error);
  }

  closeError(): void {
    this.error = null;
  }

  trackByFn(index: number): number {
    return index;
  }
}
